import React from 'react';
import { useTranslation } from "react-i18next";

function ServiceCard({ title, description, index }) {
  return (
    <div className="bg-white shadow-md rounded-lg p-6 hover:shadow-lg transition-all duration-300">
      <div className="flex items-center mb-4">
        <div className="w-10 h-10 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-semibold mr-3">
          {index + 1}
        </div>
        <h3 className="font-heading text-lg font-semibold">
          {title}
        </h3>
      </div>
      {description && (
        <p className="text-gray-600 mt-2 text-sm">
          {description}
        </p>
      )}
    </div>
  );
}

export default ServiceCard;